module.exports = __webpack_public_path__ + "img/no-images.1d98f7cb.jpg";